<mat-card class="testComparison-block">
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.testComparison.title.fullLabel"
                        | translate
                }}
                <app-tooltip
                    text="{{
                        'dashboardBizzDev.testComparison.title.summary'
                            | translate
                    }}"
                ></app-tooltip>
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ng-container *ngIf="isTestLaunched">
            <form
                [formGroup]="providerForm"
                (ngSubmit)="launchTest(getFormControls.provType.value)"
            >
                <mat-form-field>
                    <mat-label>{{
                        "dashboardBizzDev.testComparison.providerForm.fullLabel"
                            | translate
                    }}</mat-label>
                    <mat-select formControlName="provType" name="provType">
                        <mat-option
                            *ngFor="let enum of providerType"
                            [value]="enum"
                        >
                            {{ enum }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <button
                    mat-icon-button
                    type="submit"
                    color="accent"
                    matTooltip="{{
                        'dashboardBizzDev.testComparison.buttons.launch.summary'
                            | translate
                    }}"
                    [disabled]="isTestLaunched.isLaunch"
                >
                    <mat-icon aria-label="playTest">play_arrow</mat-icon>
                </button>
                <button
                    mat-icon-button
                    type="button"
                    color="accent"
                    matTooltip="{{
                        'dashboardBizzDev.testComparison.buttons.testResult.detail'
                            | translate
                    }}"
                    routerLink="/dashboardBizzDev/details/testDetails"
                >
                    <mat-icon aria-label="testDetail">search</mat-icon>
                </button>
            </form>
            <section>
                <ng-container *ngIf="isTestLaunched.isLaunch; else notLaunched">
                    <mat-icon> hourglass_full </mat-icon>
                    {{
                        "dashboardBizzDev.testComparison.launched.fullLabel"
                            | translate
                    }}
                </ng-container>
                <ng-template #notLaunched>
                    <p>
                        <mat-icon>check_circle_outline</mat-icon>
                        {{
                            "dashboardBizzDev.testComparison.notLaunched.fullLabel"
                                | translate
                        }}
                    </p>
                </ng-template>
                <hr />
                <div>
                    <ng-container *ngIf="testResult">
                        <p
                            *ngIf="
                                testResult.noMatchingCount > 0;
                                else allTestsSucceed
                            "
                            [ngStyle]="{ color: 'red' }"
                        >
                            <mat-icon>error</mat-icon
                            >{{ testResult.noMatchingCount }}
                            {{
                                "dashboardBizzDev.testComparison.result.failed.fullLabel"
                                    | translate
                            }}
                        </p>
                        <ng-template #allTestsSucceed>
                            <p [ngStyle]="{ color: 'green' }">
                                <mat-icon>done</mat-icon
                                >{{
                                    "dashboardBizzDev.testComparison.result.succeed.fullLabel"
                                        | translate
                                }}
                            </p>
                        </ng-template>
                    </ng-container>
                </div>
            </section>
        </ng-container>
    </mat-card-content>
</mat-card>
